import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

/* Components */
import AcademyInsights from "../component/learning-insights/AcademyInsights";
import StayInformedWithIndustryNews from "../component/learning-insights/StayInformedWithIndustryNews";
import BlogsAndNews from "../component/learning-insights/BlogsAndNews.jsx";
import NewsSidebar from "../component/learning-insights/News/NewsSidebar";
import CaseStudiesSection from "../component/learning-insights/CaseStudies/CaseStudiesSection";
// import { videos } from "../data/data.js"; // replace path
import LearningVideo from "../component/learning-insights/LearningVideo.jsx";
// import EventsPage from "../component/learning-insights/Events.jsx";

const LearningAndInsights = () => {
  const blogsRef = useRef(null);
  // eslint-disable-next-line
  const [showArrows, setShowArrows] = useState(false);
  const navigate = useNavigate();
  // const [isVideoOpen, setIsVideoOpen] = useState(false);
  // const [selectedVideo, setSelectedVideo] = useState(null);
  const token = localStorage.getItem("Editor_token") || null;
  const isLoggedIn = !!token;

  useEffect(() => {
    window.scrollTo(0, 0);

    const checkArrows = () => {
      if (!blogsRef.current) return;
      setShowArrows(
        blogsRef.current.scrollWidth > blogsRef.current.clientWidth
      );
    };

    checkArrows();
    window.addEventListener("resize", checkArrows);
    return () => window.removeEventListener("resize", checkArrows);
  }, []);
  //   const getYoutubeId = (url) => {
  //   const regExp =
  //     /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  //   const match = url.match(regExp);
  //   return match && match[2].length === 11 ? match[2] : null;
  // };


  return (
    <article className="min-h-screen bg-white dark:bg-[#0F172A]">
      <AcademyInsights />

      {/* BLOGS & NEWS */}
      <section className="relative">
        <div className="container mx-auto">

          <div className="flex flex-col md:flex-row items-center justify-center mb-4">
            {/* Title */}
            <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white flex-1 flex justify-center">
              Blogs & News
            </h2>

            <button
              onClick={() => {
                if (isLoggedIn) {
                  localStorage.removeItem("Editor_token");
                  navigate(0);
                } else {
                  navigate("/login");
                }
              }}
              className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors dark:text-primary dark:hover:bg-primary/20"
            >
              {isLoggedIn ? "Logout" : "Write a blog"}
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-stretch mb-10">
            {/* Blogs */}
            <div className="lg:col-span-3 flex">
              <div
                ref={blogsRef}
                className="w-full bg-gray-50 dark:bg-[#020617] rounded-2xl shadow-sm p-3 overflow-y-auto scrollbar-hide"
              >
                <BlogsAndNews />
              </div>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1 flex">
              <div className="w-full bg-gray-50 dark:bg-[#020617] rounded-2xl shadow-sm p-3 overflow-y-auto scrollbar-hide">
                <NewsSidebar />
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CASE STUDIES */}
      <section className="py-14 bg-gray-50 dark:bg-gray-900">
        <div className="mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-4 text-gray-900 dark:text-white">
            Case Studies
          </h2>
          <CaseStudiesSection />
        </div>
      </section>
      {/* VIDEOS SECTION */}

      <LearningVideo />
      {/* <EventsPage/> */}
      <StayInformedWithIndustryNews />
    </article>
  );
};

export default LearningAndInsights;
